@if ((vm$ | async); as vm) {
  <div
    (click)="isCollapsed = !isCollapsed"
    class="leverantor-header betalning-table-header">
    <div class="namn-col">
      {{vm.namn}}
    </div>
    <div class="betalning-col">
      {{vm.betalningTotal | number: '1.0-0' }}
    </div>
    <div class="percent-col">
      {{vm.snittnettoPercentage | number: '1.0-0' }}
    </div>
    <div class="total-col d-flex">
      <div>{{vm.andelTotal | number: '1.0-0' }}</div>
      <div class="ms-auto">
        <i class="fa-solid"
        [ngClass]="{ 'fa-chevron-down': isCollapsed, 'fa-chevron-up': !isCollapsed }"></i>
      </div>
    </div>
  </div>
  <div class="betalning-form"
    [(ngbCollapse)]="isCollapsed">
    <form [formGroup]="form">
      <div class="row" formGroupName="leverantor">
        <div class="col-4">
          <rask-input class="w-100"
            label="Pnr/Org Nr"
            formControlName="persOrgNR"
            [raskDisabledControl]="kontraktReadonly"
            [readonly]="true"
            [maxlengthhide]="30">
            <ng-container appendContent>
              <rask-input-validation-icon text="Kontrollera numrets giltighet"
                [isValid]="form.controls.leverantor.controls.persOrgNR.valid">
              </rask-input-validation-icon>
            </ng-container>
          </rask-input>
        </div>
        <div class="col-4">
          <rask-input class="w-100"
            label="Betaluppgifter"
            [readonly]="true"
            formControlName="betalUppgifter"
            [raskDisabledControl]="kontraktReadonly"
            [maxlengthhide]="30">
            <ng-container appendContent>
              <rask-input-validation-icon text="Kontrollera numrets giltighet"
                [isValid]="form.controls.leverantor.controls.betalUppgifter.valid">
              </rask-input-validation-icon>
            </ng-container>
          </rask-input>
        </div>
        <div class="col-4">
          <rask-textmultiline>
            <a ngbTooltip="Redigera virkesleverantör" href="#"
              (click)="openLeverantorDialog($event)">
              <span>Redigera leverantör</span>
              <i class="far fa-external-link fa-sm ms-1"></i>
            </a>
          </rask-textmultiline>
        </div>
      </div>
      @if (betalsattIsVisible()) {
        <div class="row" formGroupName="kontraktLeverantor">
          <div class="col-4">
            <rask-radiobutton-group raskYesNoOptions
              class="vertical"
              yes="Ja"
              no="Nej"
              formControlName="betalplan"
              [raskDisabledControl]="!canEditBetalsatt() || kontraktReadonly || vm.isVacsAvraknat"
              infoText="Första delbetalning för en betalplan ska ske inom 30 dagar från kontraktets undertecknande samt vara minst 5000 kr och maximalt 10% av kontraktsbeloppet. En betalplan sträcker sig över minst 2 år och upp till max tio år från betalplanens undertecknande."
              [invert]="true"
              label="Betalplan">
            </rask-radiobutton-group>
          </div>
          @if(forskottIsVisible()){
            <div class="col">
              <rask-checkbox
                [raskDisabledControl]="!canEditBetalsatt() || kontraktReadonly || vm.isVacsAvraknat"
                formControlName="forskott"
                class="forskott-checkbox"
                label="Förskott">
              </rask-checkbox>
            </div>
          }
        </div>
      }
      @if (form.controls.leverantor.invalid) {
        @if (form.controls.leverantor.controls.persOrgNR.hasError('pattern')) {
          <rask-validation-message-row
            class="mt-2"
            type="error"
            message="Person-/organisationsnummer är felformatterat. 10 eller 12 siffror. (nnnnnnnn-nnnn)">
          </rask-validation-message-row>
        }
        @if (form.controls.leverantor.controls.persOrgNR.hasError('required')) {
          <rask-validation-message-row
            class="mt-2"
            type="error"
            message="Person-/organisationsnummer är obligatoriskt">
          </rask-validation-message-row>
        }
        @if (form.controls.leverantor.controls.betalUppgifter.hasError('required')) {
          <rask-validation-message-row
            class="mt-2"
            type="error"
            message="Betaluppgifter är obligatoriskt">
          </rask-validation-message-row>
        }
      }
      <div class="betalning-container" formGroupName="betalning">
        <div class="betalningar-form">
          <rask-radiobutton-group raskYesNoOptions
            class="vertical"
            yes="Kredit"
            no="Betalning"
            [invert]="true"
            [raskDisabledControl]="form.controls.leverantor.invalid || kontraktReadonly || vm.isVacsAvraknat"
            formControlName="isKredit"
            label="Lägg till betalning">
          </rask-radiobutton-group>
          <div class="d-flex">
            <div class="col-6">
              <rask-input-number
                [useDecimalProcessor]="true"
                [isDecimal]="false"
                class="w-100"
                [min]="0"
                [inputGroup]="beloppSymbol$ | async"
                [raskDisabledControl]="form.controls.leverantor.invalid || kontraktReadonly || vm.isVacsAvraknat"
                formControlName="belopp"
                label="Belopp ex moms kr">
              </rask-input-number>
            </div>
            <div class="col-6">
              <rask-datepicker class="w-100"
                [raskMinDate]="minDate"
                [raskMaxDate]="$safeNavigationMigration(vm.resterandeUtbetalning?.utbetalningsdatum)"
                [raskDisabledControl]="form.controls.leverantor.invalid || kontraktReadonly || vm.isVacsAvraknat"
                formControlName="betaldatum"
                label="Betaldatum">
              </rask-datepicker>
            </div>
          </div>
          @if ({ isNegativtBetalningsBelopp: (negativtBetalningsBeloppSrc | async)}; as error) {
            <div>
              <rask-textmultiline [ultraTightLabel]="true">
                <div class="d-flex">
                  <rask-button type="button"
                    class="mt-0"
                    [disabled]="!form.valid || vm.kontraktsbeloppMissing || error.isNegativtBetalningsBelopp || kontraktReadonly || vm.isVacsAvraknat"
                    (click)="createBetalningSrc.next(vm)">
                    Lägg till
                  </rask-button>
                  @if (((form.controls.betalning.invalid || error.isNegativtBetalningsBelopp) && form.controls.betalning.dirty) || !(vm.kontraktsbelopp > 0)) {
                    <rask-virkeskop-validation-icon-popover entityType="betalning"
                      class="my-auto"
                      >
                      @if (vm.kontraktsbeloppMissing) {
                        <span #message>
                          Kontraktsbelopp måste vara större än noll
                        </span>
                      }
                      @if (form.controls.betalning.dirty) {
                        @if (error.isNegativtBetalningsBelopp) {
                          <span #message>
                            Leverantör kan inte ha negativ summa
                          </span>
                        }
                        @if ((form.controls.betalning.controls.belopp.hasError('min')) || form.controls.betalning.controls.belopp.hasError('required')) {
                          <span #message
                            >
                            Beloppet måste vara större än noll
                          </span>
                        }
                        @if (form.controls.betalning.controls.betaldatum.hasError('greaterThan') || form.controls.betalning.controls.betaldatum.hasError('required')) {
                          <span #message
                            >
                            Betaldatum är tidigare än dagens datum
                          </span>
                        }
                        @if (form.controls.betalning.controls.betaldatum.hasError('lessThan')) {
                          <span #message
                            >
                            Betaldatum är senare än resterande datum
                          </span>
                        }
                      }
                    </rask-virkeskop-validation-icon-popover>
                  }
                </div>
              </rask-textmultiline>
            </div>
          }
        </div>
        @if (vm.kontraktsbeloppPercentage > 75 && !vm.isRotpost) {
          <rask-validation-message-row
            class="mt-2"
            type="warning"
            message="Summa betalningar i betalplan överstiger en rekommenderad gräns på 75% av kontraktets belopp">
          </rask-validation-message-row>
        }
        @if (vm.kvarAttBetala > 0) {
          <rask-validation-message-row
            class="mt-2"
            type="warning"
            message="Summa betalningar får inte överstiga kontraktets belopp. Minska betalning med {{vm.kvarAttBetala}} kr för att kunna skicka kontraktet till VACS.">
          </rask-validation-message-row>
        }
        <div class="betalningar-list">
          <rask-list [data]="vm.betalningar">
            <rask-list-column width="25%"
              header="Belopp exkl moms">
              <ng-template let-row="row">
                <span [ngClass]="{'text-danger': row.belopp < 0}">
                  {{row.belopp | number: '1.0-0' }}
                </span>
              </ng-template>
            </rask-list-column>
            <rask-list-column width="25%"
              header="Betaldatum">
              <ng-template let-row="row">
                {{row.utbetalningsdatum | date:'yyyy-MM-dd'}}
              </ng-template>
            </rask-list-column>
            <rask-list-column>
              <ng-template let-row="row">
                @if (!row.skickadTillVacs) {
                  <rask-icon-button
                    (click)="removeBetalningSrc.next(row)"
                    icon="fa-regular fa-trash-can text-danger">
                  </rask-icon-button>
                }
              </ng-template>
            </rask-list-column>
          </rask-list>
        </div>
      </div>
    </form>
    <rask-virkeskop-validation-message [entityGuid]="vm.leverantor.guid">
    </rask-virkeskop-validation-message>
    @if (!isForskott) {
      <rask-datepicker
        raskVirkeskopRule [messageId]="['resterandedatum']"
        [raskMinDate]="vm.resterandeMinDate"
        [formControl]="resterandedatum"
        [raskDisabledControl]="kontraktReadonly"
        label="Resterande"
        infoText="Datumet skickas inte till ekonomisystemet. För att resterande köpeskilling ska betalas ut vid angivet datum kontakta virkesekonomi">
      </rask-datepicker>
    }
    @if(canCreateBetalplanUtskrift()) {
      <rask-kontrakt-generera-rapport
        [rapportTyp]="rapportTyp"
        [entityId]="virkeskopskontraktLeverantorId">
      </rask-kontrakt-generera-rapport>
    }
  </div>
}